import Joi from 'joi';
const inspirationProductsSliderSchema = Joi.object({
  type: Joi.string().valid('inspirationProductsSlider').required(),
  code: Joi.string().allow('', null).required(),
  variant: Joi.string().allow('', null).required(),
  background: Joi.string().allow('', null).required(),
  products: Joi.array().items(Joi.object().unknown(true)),
  heading: Joi.string().allow('', null).required()
}).unknown(true);
export default inspirationProductsSliderSchema;